import { motion } from 'framer-motion'
import styled from 'styled-components'

export const Background = styled(motion.div)`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background: ${({ theme }) => theme.colors.background};
  box-shadow: 0px -4px 6px 0px #0000001a;
  padding: 2rem 1.5rem 1rem 1.5rem;
  gap: 1.5rem;
  z-index: 30;
  margin: 0 auto;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;

  @media screen and (min-width: 768px) {
    box-shadow: 0px 1px 4px 2px #00000014;
    padding: 2rem;
    gap: 1.4rem;
  }

  @media screen and (min-width: 810px) {
    max-width: 77rem;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    margin-bottom: 2rem;
  }
`
export const Details = styled.div`
  margin-top: 0.4rem;
`

export const MobileSelectedSize = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  gap: 0.5rem;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const DesktopSelectedSize = styled.div`
  display: flex;
  gap: 0.6rem;
  flex-direction: column;
  align-items: flex-start;
`

export const Row = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
`

export const ProductInfo = styled.div`
  display: none;

  @media screen and (min-width: 768px) {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const MobileErrorMessageWrapper = styled.div`
  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const DesktopErrorMessageWrapper = styled.div`
  display: none;

  @media screen and (min-width: 768px) {
    display: block;
    margin-top: 1.2rem;
  }
`
